import { CellContext, ColumnDef } from '@shape-ds/components';
import { NotificationItem } from './NotificationItem';
import NotificationMenuOptions from './NotificationMenuOptions';
import { NotificationItemPayload } from 'queries/notifications/contract';

export const notificationListColumns = (): {
  [key: string]: Partial<ColumnDef<NotificationItemPayload>>;
} => {
  return {
    description: {
      size: 111,
    },
    subjects: {
      size: 111,
      enableSorting: false,
      cell: (cell: CellContext<NotificationItemPayload, unknown>) => (
        <div className="notifications-itens-wrapper">
          {cell.row.original.subjects.map((alarmDetail, index) => (
            <NotificationItem
              alarmDetails={alarmDetail}
              key={alarmDetail.alarm_field_type + index}
            />
          ))}
        </div>
      ),
    },
    edit: {
      size: 100,
      enableSorting: false,
      cell: () => <NotificationMenuOptions />,
    },
  };
};
